import { OrderItemTrackingStatusEnum } from '@models';

export const DATE_EXPECTED_LABEL = 'Expected delivery:';
export const DATE_DELIVERY_LABEL = 'Delivery date:';
export const DATE_CANCELATION_LABEL = 'Cancelation date:';
export const DATE_LABELS_BY_STATUS: Record<OrderItemTrackingStatusEnum, string> = {
  [OrderItemTrackingStatusEnum.Ordered]: '',
  [OrderItemTrackingStatusEnum.Shipped]: DATE_EXPECTED_LABEL,
  [OrderItemTrackingStatusEnum.Delivered]: DATE_DELIVERY_LABEL,
  [OrderItemTrackingStatusEnum.Returned]: '',
  [OrderItemTrackingStatusEnum.Canceled]: DATE_CANCELATION_LABEL,
  [OrderItemTrackingStatusEnum.DeliveredInReturn]: '',
  [OrderItemTrackingStatusEnum.Submitted]: '',
  [OrderItemTrackingStatusEnum.PaymentPending]: '',
  [OrderItemTrackingStatusEnum.PaymentFailed]: '',
  [OrderItemTrackingStatusEnum.FraudHeld]: '',
  [OrderItemTrackingStatusEnum.ReturnReceived]: '',
  [OrderItemTrackingStatusEnum.ReturnStarted]: '',
  [OrderItemTrackingStatusEnum.Failed]: '',
  [OrderItemTrackingStatusEnum.Declined]: '',
};
